module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('ul', {
    staticClass: "pagination"
  }, [(_vm.page > 1) ? _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Previous"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.changePage(0)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("«")])])]) : _vm._e(), _vm._v(" "), (_vm.page > 5) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextPages(_vm.index - 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("...")])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.paginationPages), function(_page) {
    return _c('li', {
      class: {
        'active': (_page + (_vm.index * 5)) - 1 == (_vm.page)
      }
    }, [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (((_page + (_vm.index * 5)) - 1) <= _vm.totalPages),
        expression: "((_page + (index*5))-1) <= totalPages"
      }],
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changePage((_page + (_vm.index * 5)) - 1)
        }
      }
    }, [_vm._v(_vm._s(_page + (_vm.index * 5)))])])
  }), _vm._v(" "), (_vm.totalPages > 5 && ((_vm.totalPages - _vm.page) >= 5)) ? _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.nextPages(_vm.index + 1)
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("...")])])]) : _vm._e(), _vm._v(" "), (_vm.totalPages > 5 && _vm.page != _vm.totalPages) ? _c('li', [_c('a', {
    attrs: {
      "href": "#",
      "aria-label": "Next"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.lastPage()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("»")])])]) : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-067ef189","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/table/DWPagination.vue
// module id = 823
// module chunks = 1